import { useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { getPreorderData } from '../../redux/PreorderSlice/PreorderSelectors';
import { getOrderData } from '../../redux/OrderSlice/OrderSelectors';
import CopyButton from '../CopyButton/CopyButton';
import styles from './AdditionalInfo.module.scss';

const messages = defineMessages({
	orderAmount: {
		id: 'payments.order_amount',
		defaultMessage: 'Order amount',
	},
	orderId: {
		id: 'payments.order_id',
		defaultMessage: 'Order ID',
	},
	description: {
		id: 'payments.description',
		defaultMessage: 'Description',
	},
});

const InfoRow = ({
	label,
	value,
	isCopyEnabled = false,
}: {
	label: string;
	value: string;
	isCopyEnabled?: boolean;
}) => {
	return (
		<div className={styles.field}>
			<span>{label}</span>
			<span className={styles.value}>
				{value}
				{isCopyEnabled && <CopyButton dataToCopy={value} />}
			</span>
		</div>
	);
};

const AdditionalInfo = () => {
	const { formatMessage } = useIntl();
	const preorderData = useSelector(getPreorderData) || ({} as any);

	const orderData = useSelector(getOrderData) || ({} as any);

	const receiveAmount = orderData?.receiveAmount || preorderData?.receiveAmount;
	const receiveCurrencyCode = orderData?.receiveCurrencyCode || preorderData?.receiveCurrencyCode;
	const orderId = orderData?.orderId || preorderData?.orderId;
	const description = orderData?.description || preorderData?.description;

	return (
		<div className={styles.container}>
			{!!receiveAmount && !!receiveCurrencyCode && (
				<InfoRow
					label={formatMessage(messages.orderAmount)}
					value={`${receiveAmount} ${receiveCurrencyCode}`}
				/>
			)}
			{!!orderId && (
				<InfoRow isCopyEnabled label={formatMessage(messages.orderId)} value={orderId} />
			)}
			{!!description && (
				<InfoRow label={formatMessage(messages.description)} value={description} />
			)}
		</div>
	);
};

export default AdditionalInfo;
